// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-PlmInputSearch-PlmInputSearch-module__input--JIB2H .ant-input-prefix {
  margin-inline-end: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/PlmInputSearch/PlmInputSearch.module.less"],"names":[],"mappings":"AAAA;EAEI,uBAAA;AAAJ","sourcesContent":[".input {\n  :global(.ant-input-prefix) {\n    margin-inline-end: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": `src-components-PlmInputSearch-PlmInputSearch-module__input--JIB2H`
};
export default ___CSS_LOADER_EXPORT___;
